<template>
  <section v-if="totalCount != 0">
    <div class="column is-12">
      <div class="columns is-mobile">
        <div
          class="column is-narrow is-size-5 has-text-black has-text-weight-bold is-7"
        >
          {{ $t(title) }}
        </div>
        <div class="column"></div>
        <div class="column is-narrow">
          <span class="has-text-weight-bold is-size-5">
            {{ totalCount }}
          </span>
          <span class="has-text-grey">
            {{ $t('trainingInTrainingPage') }}
          </span>
        </div>
      </div>
    </div>
    <div
      v-if="!loading && trainings.length"
      class="columns is-mobile is-centered-mobile has-margin-5-mobile is-multiline"
    >
      <div
        v-for="(training, index) in trainings"
        :key="`training-${index}`"
        class="column is-mobile is-12-mobile pointer has-margin-bottom-10-mobile is-3-desktop"
        @click="openDetailPage(training.slug)"
      >
        <vue-hover>
          <template v-slot="{ hover }">
            <div
              class="box is-paddingless outline rounded-10 lift-shadow"
              :class="{
                'is-shadowless': !hover,
                'min-height-15rem': isUpcoming,
                'min-height-18rem': !isUpcoming
              }"
            >
              <div class="card-image">
                <figure class="image is-3by2">
                  <img
                    class="border-top-left-radius-10px border-top-right-radius-10px"
                    :src="get(training, 'image')"
                  />
                </figure>
                <div
                  v-if="hover"
                  class="modal-background has-opacity-half border-top-left-radius-10px border-top-right-radius-10px"
                ></div>
              </div>
              <div class="card-content pa-3">
                <div
                  :title="training.title"
                  class="has-text-weight-bold dark-blue--text"
                >
                  {{
                    $i18n.locale === 'ne'
                      ? $options.truncateChars(get(training, 'title_ne'), 20)
                      : $options.truncateChars(get(training, 'title'), 20)
                  }}
                </div>
                <span
                  v-if="
                    training &&
                    training.data &&
                    training.data.show_training_cost
                  "
                >
                  <div
                    v-if="get(training, 'data.price') > 0"
                    class="has-text-weight-bold has-text-grey"
                  >
                    {{
                      'NRs. ' +
                        parseInt(get(training, 'data.price')).toLocaleString(
                          'en-IN'
                        ) || 'N/A'
                    }}
                  </div>
                  <div v-else class="has-text-weight-bold has-text-grey">
                    {{ $t('Free') }}
                  </div>
                </span>

                <div v-if="!isUpcoming">
                  <div class="is-size-7">
                    {{
                      `${$options.getHumanizeDate(
                        get(training, 'start_at')
                      )} - ${$options.getHumanizeDate(get(training, 'end_at'))}`
                    }}
                  </div>
                  <div class="is-size-7">
                    {{
                      get(training, 'data.duration') +
                        ' ' +
                        get(training, 'data.unit') || 'N/A'
                    }}
                  </div>
                </div>
              </div>
            </div>
          </template>
        </vue-hover>
      </div>
      <div class="column is-12">
        <pagination
          v-model="paginationController.page"
          :page-size="paginationController.itemsPerPage"
          :collection-name="collectionName"
          @scroll="$emit('scroll')"
        ></pagination>
      </div>
    </div>
    <div v-else class="columns">
      <div class="column">
        <vue-no-data :loading="loading"></vue-no-data>
      </div>
    </div>
  </section>
</template>
<script>
import VueHover from '@/components/Commons/VueHover'
import { getResouceUrl } from '@/helpers/utils/searchUtils'
import Pagination from '@/components/Commons/Pagination'
import VueNoData from '@/components/Commons/VueNoData'
import { getHumanizeDate } from '@/helpers/utils/date'
import { truncateChars } from '@/helpers/utils/common'

export default {
  getHumanizeDate,
  components: { VueNoData, Pagination, VueHover },
  props: {
    collectionName: {
      type: String,
      default: ''
    },
    isUpcoming: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  truncateChars,
  data() {
    return {
      filterFields: {
        status: this.isUpcoming ? 'upcoming' : 'current'
      },
      paginationController: {
        page: 1,
        itemsPerPage: 8
      },
      totalCount: 0,
      loading: false
    }
  },
  computed: {
    trainings() {
      return (
        this.get(this.$store.state.collection.collectionResponses, [
          this.collectionName,
          'results'
        ]) || []
      )
    }
  },
  watch: {
    'paginationController.page': {
      handler(newVal) {
        const offset = this.paginationController.itemsPerPage * (newVal - 1)
        this.$set(this.filterFields, 'offset', offset)
        this.$set(
          this.filterFields,
          'limit',
          this.paginationController.itemsPerPage
        )

        this.$router.push({
          query: {
            ...this.$route.query,
            limit: this.filterFields.limit,
            offset: this.filterFields.offset
          }
        })

        window.history.replaceState(
          { limit: this.filterFields.limit, offset: this.filterFields.offset },
          'Pagination State'
        )

        this.getTrainings()
      }
    }
  },
  mounted() {
    this.filterFields.limit = this.paginationController.itemsPerPage

    const { limit, offset } = this.$route.query

    if (limit) {
      this.filterFields.limit = Number(limit)
    }

    if (offset) {
      this.filterFields.offset = Number(offset)
      this.paginationController.page =
        Math.floor(this.filterFields.offset / this.filterFields.limit) + 1
    }

    this.getTrainings()
  },
  methods: {
    getTrainings() {
      this.loading = true
      const contentUrl = `/api/v1/training/`
      const resourceUrl = getResouceUrl(contentUrl, this.filterFields)
      this.$axios
        .get(resourceUrl)
        .then(({ data }) => {
          this.$store.commit('collection/setCollectionData', [
            this.collectionName,
            data
          ])
          this.totalCount = data.count
          this.$emit('totalCount', data.count)
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDetailPage(slug) {
      this.$router.push(
        this.localePath({
          name: 'training-slug',
          params: { slug }
        })
      )
    }
  }
}
</script>
<style lang="css">
.has-opacity-half {
  opacity: 0.5;
}
</style>
